// Short-TTL cache for GET responses that don't need to be fresh on every
// mount (e.g. home page collections). Backed by sessionStorage so it also
// survives a page refresh within the same tab, not just SPA navigation.
const CACHE_PREFIX = "api_cache:";
const DEFAULT_TTL_MS = 10 * 60 * 1000;

export const getCachedOrFetch = async (key, fetcher, ttlMs = DEFAULT_TTL_MS) => {
  const storageKey = `${CACHE_PREFIX}${key}`;
  try {
    const raw = sessionStorage.getItem(storageKey);
    if (raw) {
      const { data, timestamp } = JSON.parse(raw);
      if (Date.now() - timestamp < ttlMs) {
        return data;
      }
    }
  } catch (err) {
    // Corrupted entry or storage unavailable — fall through and refetch.
  }

  const data = await fetcher();

  try {
    sessionStorage.setItem(
      storageKey,
      JSON.stringify({ data, timestamp: Date.now() }),
    );
  } catch (err) {
    // Storage full/disabled (e.g. private mode) — cache is best-effort.
  }

  return data;
};

export const invalidateCache = (key) => {
  try {
    sessionStorage.removeItem(`${CACHE_PREFIX}${key}`);
  } catch (err) {
    // no-op
  }
};
